<template>
  <section class="dp-layout dorm-module">

    <section class="dp-left">
      <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
    </section>


    <section class="dp-right dorm-card history-content-panel">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList">
        <el-form-item v-if="isBlogAdmin" slot="buttonSlot">
          <el-button type="warning" icon="el-icon-upload2" @click="openSimulateDialog">模拟上报</el-button>
        </el-form-item>
      </toolbar>

      <!--列表：相关字段上下合并，减少横向滚动-->
      <div class="tbl-scroll-host">
      <el-table
        :data="users"
        v-loading="listLoading"
        @select="dialogCheck"
        @row-click="selectCurrentRow"
        ref="table"
        height="100%" style="width: 100%"
        class="custom-tbl dorm-history-tbl"
      >
        <el-table-column type="selection" width="46" />

        <el-table-column label="人员" min-width="120" align="left" header-align="left">
          <template slot-scope="scope">
            <div class="cell-stack">
              <div class="cell-main">{{ scope.row.UserName || '—' }}</div>
              <div class="cell-sub">卡号 {{ scope.row.CardId || '—' }}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="位置" min-width="150" align="left" header-align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="cell-stack">
              <div class="cell-main">{{ scope.row.DepartmentName || '—' }}</div>
              <div class="cell-sub">{{ scope.row.BedsDesc || '暂无入住' }}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="终端 / 方向" min-width="150" align="left" header-align="left">
          <template slot-scope="scope">
            <div class="cell-stack cell-dir">
              <div class="cell-main">{{ scope.row.KqTerminalId || '—' }}</div>
              <div class="cell-dir-tags">
                <el-tag
                  size="mini"
                  effect="plain"
                  :type="touchTypeTagType(scope.row.TouchType)"
                >{{ touchTypeText(scope.row.TouchType) }}</el-tag>
                <el-tag
                  v-if="scope.row.ResolvedDirectionName"
                  size="mini"
                  effect="plain"
                  :type="resolvedDirTagType(scope.row.ResolvedDirectionName)"
                >{{ scope.row.ResolvedDirectionName }}</el-tag>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="方向来源" width="112" align="center" header-align="center">
          <template slot-scope="scope">
            <el-tag
              size="mini"
              effect="plain"
              :type="directionSourceTagType(scope.row.DirectionSource)"
            >{{ directionSourceText(scope.row.DirectionSource) }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="时间" min-width="158" align="left" header-align="left">
          <template slot-scope="scope">
            <div class="cell-stack">
              <div class="cell-main">刷 {{ formatShortTime(scope.row.TouchTime) }}</div>
              <div class="cell-sub">报 {{ formatShortTime(scope.row.ReportTime) }}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="匹配状态" width="110" align="center" header-align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="matchTagType(scope.row.MatchStatusName)" effect="plain">
              {{ scope.row.MatchStatusName || '—' }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column label="媒体" width="88" align="center" header-align="center">
          <template slot-scope="scope">
            <oss-media-thumbs :media="scope.row.KqImageFile" />
          </template>
        </el-table-column>

        <el-table-column label="处理结果" min-width="140" align="left" header-align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ processResultText(scope.row) }}</template>
        </el-table-column>
      </el-table>
      </div>

      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10" :total="total"
          style="float: right"></el-pagination>
      </el-col>
    </section>

    <!-- 模拟上报弹窗：仅 blogadmin / admin -->
    <el-dialog
      title="模拟宿舍考勤上报"
      :visible.sync="simulateVisible"
      width="520px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form ref="simulateForm" :model="simulateForm" :rules="simulateRules" label-width="96px" size="small">
        <el-form-item label="终端" prop="KqTerminalId">
          <el-select
            v-model="simulateForm.KqTerminalId"
            filterable
            clearable
            placeholder="选择宿管终端"
            style="width: 100%"
            @change="onTerminalChange"
          >
            <el-option
              v-for="d in terminalOptions"
              :key="d.KqTerminalId"
              :label="(d.TerminalName || d.KqTerminalId) + '（' + d.KqTerminalId + '）'"
              :value="d.KqTerminalId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="学生" prop="UserId">
          <el-select
            v-model="simulateForm.UserId"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="输入姓名/学号/卡号搜索（至少2字）"
            :remote-method="searchStudents"
            :loading="studentLoading"
            :no-data-text="studentSearchHint"
            style="width: 100%"
            @change="onStudentChange"
            @visible-change="onStudentSelectVisible"
          >
            <el-option
              v-for="s in studentOptions"
              :key="s.Id"
              :label="formatStudentOption(s)"
              :value="String(s.Id)"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="方向" prop="TouchType">
          <el-radio-group v-model="simulateForm.TouchType">
            <el-radio label="in">进入</el-radio>
            <el-radio label="out">离开</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="刷卡时间" prop="TouchTime">
          <el-date-picker
            v-model="simulateForm.TouchTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择刷卡时间"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="simulateVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="simulateLoading" @click="submitSimulate">提交上报</el-button>
      </div>
    </el-dialog>

  </section>
</template>

<script>
import util from "../../../util/date";
import {
  getHostelGatherRawHistoryListPage,
  getKqtDeviceTerminalListPage,
  simulateHostelReportAttendance
} from '../../api/modules/attendance';
import { getStudentInfoListPage } from '../../api/modules/personnel';
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import '../../styles/dorm-module.css'
import superAdminMixin from '../../mixins/superAdminMixin'

export default {
  components: { Toolbar, DepartmentPane },
  mixins: [superAdminMixin],
  data() {
    return {
      filters: {
      },
      searchList: [
        {
          label: '姓名',
          key: 'name',
        },
        {
          label: '卡号',
          key: 'cardId',
        },
        {
          label: '日期',
          key: 'date',
          type: 'date'
        },
      ],
      buttonList: [],
      options: [],
      users: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      statusList: [
        { name: "激活", value: true },
        { name: "禁用", value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      isResouceShow: 0,
      DepartmentId: "",
      BaseApiUrl: BaseApiUrl, //网络前缀
      currentUser: null,
      simulateVisible: false,
      simulateLoading: false,
      terminalOptions: [],
      studentOptions: [],
      studentLoading: false,
      studentSearchHint: '请输入关键字搜索',
      lastStudentQuery: '',
      simulateForm: {
        KqTerminalId: '',
        UserId: '',
        CardId: '',
        TouchType: 'in',
        TouchTime: ''
      },
      simulateRules: {
        KqTerminalId: [{ required: true, message: '请选择终端', trigger: 'change' }],
        UserId: [{ required: true, message: '请选择学生', trigger: 'change' }],
        TouchType: [{ required: true, message: '请选择方向', trigger: 'change' }],
        TouchTime: [{ required: true, message: '请选择刷卡时间', trigger: 'change' }]
      }
    };
  },
  computed: {
    schoolDepartmentId() {
      return this.$store.state.activeSchoolId || window.localStorage.getItem('activeSchoolId') || this.DepartmentId || ''
    }
  },
  methods: {

    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.handleQuery();
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },
    //获取用户列表
    handleQuery() {
      let _this = this;
      const departmentId = this.DepartmentId || this.schoolDepartmentId
      if (!departmentId) {
        this.$message.warning('请先选择学校或组织')
        return
      }
      let para = {
        page: this.page,
        departmentId,
        ...this.filters,
      };
      this.listLoading = true;
      //NProgress.start();
      getHostelGatherRawHistoryListPage(para).then(async (res) => {
        if (!res.data || !res.data.success) {
          this.$message.error((res.data && res.data.msg) || '获取失败')
          this.users = []
          this.total = 0
          return
        }
        this.total = res.data.response.dataCount;
        const rows = res.data.response.data || [];
        await this.prefetchListOssMedia(rows, 'KqImageFile');
        this.users = rows;
      }).catch(() => {
        this.users = []
        this.total = 0
        this.$message.error('请求失败')
      }).finally(() => {
        this.listLoading = false;
        //NProgress.done();
      });
    },

    formatNow() {
      const d = new Date()
      const p = (n) => (n < 10 ? '0' + n : '' + n)
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`
    },
    /** 时间列上下显示：优先 HH:mm:ss，过长则原样 */
    formatShortTime(v) {
      if (!v) return '—'
      const s = String(v)
      const m = s.match(/(\d{2}:\d{2}:\d{2})/)
      if (m) {
        const day = s.slice(0, 10)
        return day && day.indexOf('-') > 0 ? `${day} ${m[1]}` : m[1]
      }
      return s
    },
    touchTypeText(t) {
      if (t === 'in') return '进入'
      if (t === 'out') return '离开'
      if (t === 'inout') return '出入'
      return t || '—'
    },
    touchTypeTagType(t) {
      if (t === 'in') return 'success'
      if (t === 'out') return 'warning'
      if (t === 'inout') return 'info'
      return 'info'
    },
    directionSourceText(source) {
      const map = {
        TIME_WINDOW: '时间段推断',
        PRESENCE_STATE: '在寝状态推断',
        DEVICE: '设备上报',
        TERMINAL_BINDING: '绑定方向',
        UNKNOWN: '无法判断'
      }
      return map[source] || source || '—'
    },
    directionSourceTagType(source) {
      if (source === 'TIME_WINDOW') return 'success'
      if (source === 'PRESENCE_STATE') return 'warning'
      if (source === 'UNKNOWN') return 'danger'
      return 'info'
    },
    resolvedDirTagType(name) {
      const n = String(name || '')
      if (n.indexOf('归') >= 0) return 'success'
      if (n.indexOf('离') >= 0) return 'warning'
      return 'info'
    },
    matchTagType(name) {
      const n = String(name || '')
      if (n.indexOf('已计入') >= 0) return 'success'
      if (n.indexOf('未采纳') >= 0 || n.indexOf('拒绝') >= 0 || n.indexOf('失败') >= 0) return 'danger'
      if (n.indexOf('忽略') >= 0 || n.indexOf('只更新') >= 0 || n.indexOf('不计') >= 0) return 'info'
      if (n.indexOf('不明') >= 0 || n.indexOf('歧义') >= 0) return 'warning'
      return ''
    },
    processResultText(row) {
      const value = row && (row.ProcessResult || row.RejectReason || '')
      const map = {
        DormPresenceUpdated: '已更新在寝状态',
        DormAttendanceDisabled: '未启用宿舍考勤',
        TerminalDirectionInvalid: '终端方向无效',
        DirectionConflict: '方向冲突',
        DirectionUnknown: '方向无法判断',
        StudentNotFound: '未找到学生',
        NotResident: '无入住资格',
        NotCheckedIn: '未入住',
        BuildingMismatch: '楼栋不匹配'
      }
      return map[value] || value || '—'
    },
    formatStudentOption(s) {
      const name = s.StuName || s.Name || ''
      const card = this.resolveStudentCard(s) || '无卡'
      const no = s.StuCode || s.StuNo || s.StudentNo || ''
      return no ? `${name} / ${no} / ${card}` : `${name} / ${card}`
    },
    /** 主卡号优先，否则取附属卡（与人员档案 domains 一致） */
    resolveStudentCard(s) {
      if (!s) return ''
      if (s.CardNumber) return String(s.CardNumber).trim()
      const domains = s.domains || s.Domains || []
      if (domains.length) {
        const first = domains[0]
        const v = (first && (first.value || first.Value || first.cardId || first.CardId)) || ''
        if (v) return String(v).trim()
      }
      if (s.OtherCardNo) {
        const part = String(s.OtherCardNo).split(/[，,]/)[0]
        return (part || '').trim()
      }
      return ''
    },
    async openSimulateDialog() {
      if (!this.isBlogAdmin) return
      this.simulateForm = {
        KqTerminalId: '',
        UserId: '',
        CardId: '',
        TouchType: 'in',
        TouchTime: this.formatNow()
      }
      this.studentOptions = []
      this.lastStudentQuery = ''
      this.studentSearchHint = '请输入关键字搜索'
      this.simulateVisible = true
      await this.loadTerminals()
      // 不预拉全校名单：三千四千人不能塞进下拉
    },
    onStudentSelectVisible(visible) {
      if (!visible) return
      if (!this.studentOptions.length) {
        this.studentSearchHint = '请输入姓名/学号/卡号（至少2字）'
      }
    },
    async loadTerminals() {
      const res = await getKqtDeviceTerminalListPage({
        page: 1,
        intPageSize: 200,
        type: '2',
        departmentId: this.schoolDepartmentId || undefined
      })
      this.terminalOptions = (res.data && res.data.response && res.data.response.data) || []
      if (!this.simulateForm.KqTerminalId && this.terminalOptions.length) {
        this.simulateForm.KqTerminalId = this.terminalOptions[0].KqTerminalId
        this.onTerminalChange(this.simulateForm.KqTerminalId)
      }
    },
    onTerminalChange(id) {
      const d = (this.terminalOptions || []).find(x => x.KqTerminalId === id)
      if (d && d.TouchTypeDirection && ['in', 'out'].includes(d.TouchTypeDirection)) {
        this.simulateForm.TouchType = d.TouchTypeDirection
      }
    },
    /**
     * 远程搜索学生：必须关键字，最多返回 30 条（避免全校名单进下拉）
     */
    async searchStudents(query) {
      const q = (query || '').trim()
      this.lastStudentQuery = q
      if (q.length < 2) {
        this.studentOptions = []
        this.studentSearchHint = q ? '请再输入至少1个字' : '请输入姓名/学号/卡号（至少2字）'
        return
      }
      this.studentLoading = true
      this.studentSearchHint = '无匹配学生'
      try {
        const para = {
          page: 1,
          intPageSize: 30,
          departmentId: this.schoolDepartmentId || this.DepartmentId || undefined,
          forDormCheckIn: 1
        }
        // 纯数字才按卡号；英文名走姓名
        if (/^\d+$/.test(q)) para.cardNo = q
        else para.stuName = q
        const res = await getStudentInfoListPage(para)
        const list = (res.data && res.data.response && res.data.response.data) || []
        this.studentOptions = list
        if (!list.length) this.studentSearchHint = '无匹配学生'
      } finally {
        this.studentLoading = false
      }
    },
    onStudentChange(userId) {
      const s = (this.studentOptions || []).find(x => String(x.Id) === String(userId))
      this.simulateForm.CardId = this.resolveStudentCard(s)
    },
    submitSimulate() {
      this.$refs.simulateForm.validate(async (ok) => {
        if (!ok) return
        // 上报接口可用 UserId；有卡则一并带上便于终端侧对照
        if (!this.simulateForm.UserId && !this.simulateForm.CardId) {
          this.$message.warning('请选择学生')
          return
        }
        this.simulateLoading = true
        try {
          const touchTime = this.simulateForm.TouchTime
          const res = await simulateHostelReportAttendance({
            UserId: this.simulateForm.UserId || '',
            CardId: this.simulateForm.CardId || '',
            KqTerminalId: this.simulateForm.KqTerminalId,
            TouchType: this.simulateForm.TouchType,
            TouchTime: touchTime,
            ReportTime: touchTime,
            UserRole: 'student',
            BusinessDesc: '模拟上报'
          }, { skipCache: true })
          if (res.data && res.data.success) {
            this.$message.success(res.data.msg || '模拟上报成功')
            this.simulateVisible = false
            this.handleQuery()
          } else {
            this.$message.error((res.data && res.data.msg) || '模拟上报失败')
          }
        } catch (e) {
          this.$message.error('模拟上报请求失败')
        } finally {
          this.simulateLoading = false
        }
      })
    }
  },
  mounted() {
    if (window.localStorage.user) {
      try {
        this.currentUser = JSON.parse(window.localStorage.user)
      } catch (e) {
        this.currentUser = null
      }
    }
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];

    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.history-content-panel {
  padding: 12px 14px;
}

.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
.cell-stack {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  line-height: 1.35;
  padding: 2px 0;
  width: 100%;
  text-align: left;
}
.cell-main {
  color: #303133;
  font-size: 13px;
  font-weight: 600;
}
.cell-sub {
  color: #909399;
  font-size: 12px;
}
.cell-dir-tags {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  margin: 0;
  padding: 0;
  width: 100%;
}
/* 覆盖 Element 默认 .el-tag+.el-tag 左边距，避免两行间距不一致 */
.cell-dir-tags /deep/ .el-tag {
  margin: 0 !important;
  height: 20px;
  line-height: 18px;
  padding: 0 6px;
}
.dorm-history-tbl /deep/ .el-table__body td {
  vertical-align: middle;
}
/* 覆盖全局 split-layout 表头强制居中，与内容对齐保持一致 */
.dorm-history-tbl /deep/ th.el-table__cell.is-left,
.dorm-history-tbl /deep/ th.el-table__cell.is-left > .cell,
.dorm-history-tbl /deep/ td.el-table__cell.is-left,
.dorm-history-tbl /deep/ td.el-table__cell.is-left > .cell {
  text-align: left !important;
}
.dorm-history-tbl /deep/ th.el-table__cell.is-center,
.dorm-history-tbl /deep/ th.el-table__cell.is-center > .cell,
.dorm-history-tbl /deep/ td.el-table__cell.is-center,
.dorm-history-tbl /deep/ td.el-table__cell.is-center > .cell {
  text-align: center !important;
}
</style>
